import { Middleware } from '@nuxt/types'

const initStore: Middleware = async({ $accessor, $config, $sentry, store, $auth, route }) => {
  if ($auth.loggedIn && !store.state.initialized) {
    $accessor.fetchListController(route.fullPath)
    await $accessor.initStore($config)
      .catch((err: Error) => $sentry.captureException(err))
  }
}

export default initStore
